import React from 'react';

import HoneyTable, { makeRelativeTime, makeCountryName, makeTargetService } from './HoneyTable.js'

function ConnAttemps({latestConsumptions}) {
  return (
    <HoneyTable
      titleBefore="Latest&nbsp;"
      titleHoney="Intrusion"
      titleAfter="&nbsp;Attemps"
      fields={["Received", "IPv4", "TargetService", "CountryName"]}
      pagination={true}
      data={latestConsumptions}
      dataTransform={[makeRelativeTime, makeCountryName, makeTargetService]}
    />
  );
}

export default ConnAttemps;
